export default {
  'Resize for': 'Resize for',
  'Add 10 videos at most': 'Add 10 videos at most. ',
}